/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import SwitchField from "components/SwitchField";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  marginBottom: 20,
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const initRow = [
  {
    id: 1,
    value: {
      chon: false,
      maHoSo: "",
      duAnCungTinh: false,
      tenDuAn: "",
      diaChiThucHien: "",
      tinhTp: "",
      quanHuyen: "",
      xaPhuong: "",
      tenChuDuAn: "",
      mstChuDuAn: "",
      tinhDongTruSo: "",
      coQuanThueCapCuc: "",
      coQuanThueQuanLy: "",
      so: 0,
      ngay: "",
      coQuanBanHanh: "",
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [row, setRow] = useState(initRow);

  useEffect(() => {
    setFieldValue("valuesTable", row);
  }, [row]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setRow((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    const newIdValue = row.length + 1;
    const newRow = {
      id: newIdValue,
      value: {
        chon: false,
        maHoSo: "",
        duAnCungTinh: false,
        tenDuAn: "",
        diaChiThucHien: "",
        tinhTp: "",
        quanHuyen: "",
        xaPhuong: "",
        tenChuDuAn: "",
        mstChuDuAn: "",
        tinhDongTruSo: "",
        coQuanThueCapCuc: "",
        coQuanThueQuanLy: "",
        so: 0,
        ngay: "",
        coQuanBanHanh: "",
      },
    };
    setRow((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (row.length !== 1) {
      row.pop();
      const newRow = row;
      setRow([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center", minWidth: 50 }} rowSpan={2}>
                  STT
                </Th>
                <Th style={{ textAlign: "center", minWidth: 70 }} rowSpan={2}>
                  Chọn
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} rowSpan={2}>
                  Mã hồ sơ khai DAĐT
                </Th>
                <Th style={{ textAlign: "center", minWidth: 100 }} rowSpan={2}>
                  Dự án cùng tỉnh
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} colSpan={8}>
                  Thông tin dự án đầu tư
                </Th>
                <Th style={{ textAlign: "center", minWidth: 500 }} colSpan={2}>
                  Cơ quan thuế quản lý nơi có DAĐT
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} colSpan={3}>
                  Văn bản phê duyệt DAĐT
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center", minWidth: 400 }}>Tên dự án đầu tư</Th>
                <Th style={{ textAlign: "center", minWidth: 400 }}>Địa chỉ thực hiện dự án</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>Tỉnh/Thành phố</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>Quận/Huyện</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>Xã/Phường</Th>
                <Th style={{ textAlign: "center", minWidth: 400 }}>Tên chủ dự án đầu tư</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>MST chủ dự án đầu tư</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>
                  Tỉnh nơi chủ dự án đóng trụ sở
                </Th>
                <Th style={{ textAlign: "center", minWidth: 300 }}>Cơ quan thuế cấp cục</Th>
                <Th style={{ textAlign: "center", minWidth: 300 }}>Cơ quan thuế quản lý DAĐT</Th>
                <Th style={{ textAlign: "center", minWidth: 100 }}>Số</Th>
                <Th style={{ textAlign: "center", minWidth: 300 }}>Ngày</Th>
                <Th style={{ textAlign: "center", minWidth: 300 }}>Cơ quan ban hành</Th>
              </tr>
            </thead>
            <tbody>
              {row &&
                row.length > 0 &&
                row.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      {rows.id}
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <SwitchField id={rows.id} name={"chon"} value={rows.value.chon} />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="maHoSo"
                        value={rows.value.maHoSo}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <SwitchField
                        id={rows.id}
                        name={"duAnCungTinh"}
                        value={rows.value.duAnCungTinh}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="tenDuAn"
                        value={rows.value.tenDuAn}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="diaChiThucHien"
                        value={rows.value.diaChiThucHien}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="tinhTp"
                        value={rows.value.tinhTp}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="quanHuyen"
                        value={rows.value.quanHuyen}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="xaPhuong"
                        value={rows.value.xaPhuong}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="tenChuDuAn"
                        value={rows.value.tenChuDuAn}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="mstChuDuAn"
                        value={rows.value.mstChuDuAn}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="tinhDongTruSo"
                        value={rows.value.tinhDongTruSo}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="coQuanThueCapCuc"
                        value={rows.value.coQuanThueCapCuc}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="coQuanThueQuanLy"
                        value={rows.value.coQuanThueQuanLy}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="so"
                        type="number"
                        value={rows.value.so}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="ngay"
                        type="date"
                        value={rows.value.ngay}
                        onChange={handleChange}
                      />
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="coQuanBanHanh"
                        value={rows.value.coQuanBanHanh}
                        onChange={handleChange}
                      />
                    </Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type == "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      const newValue = value;
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      const newValue = value;
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        marginTop: 13,
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
